import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import React, { useEffect, useRef } from 'react';
import { Tab, Tabs } from 'react-tabs-scrollable';
import 'react-tabs-scrollable/dist/rts.css';
import './CustomTabs.css';

/** MyMine Version2.0 共通化に伴い新規作成
 * CustomTabs
 */
const CustomTabs = ({ selectedTabIndex, setSelectedTabIndex, tabCaptionList, tabContents, isArrowTab, isPc }) => {

  const prevButtonRef = useRef();
  const nextButtonRef = useRef();

  useEffect(() => {

    const setAriaHidden = () => {
      // AriaHiddenプロパティをfalseにしないとコンソールエラーが出てしまうため、設定
      setTimeout(() => {
        if (prevButtonRef.current)
          prevButtonRef.current.setAttribute('aria-hidden', false);
        if (nextButtonRef.current)
          nextButtonRef.current.setAttribute('aria-hidden', false);
      }, 500)
    }
    setAriaHidden();
    window.addEventListener('resize', setAriaHidden);

    return () => {
      window.removeEventListener('resize', setAriaHidden);
    };

  }, [prevButtonRef, nextButtonRef])

  return (
    <>
      <Tabs
        activeTab={selectedTabIndex}
        onTabClick={(e, index) => setSelectedTabIndex(index)}
        hideNavBtnsOnMobile={false}
        tabsContainerStyle={isArrowTab ? { padding: '30px 0 0 0', border: 0 } : { padding: 0, border: 0 }}
        tabsUpperContainerStyle={{ padding: 0, border: 0 }}
        leftNavBtnRef={prevButtonRef}
        rightNavBtnRef={nextButtonRef}
        leftBtnIcon={<ArrowBackIosNewIcon focusable={null} aria-hidden={null} fontSize='small' />}
        rightBtnIcon={<ArrowForwardIosIcon focusable={null} aria-hidden={null} fontSize='small' />}
        tabsContainerClassName={isArrowTab & isPc ? 'arrow-tab-container' : isArrowTab ? 'arrow-tab-container-mobile' : '' }
        tabsClassName={isArrowTab & isPc ? 'arrow-tab-container' : isArrowTab ? 'arrow-tab-container-mobile' : ''}
        scrollButtons
        allowScrollButtonsMobile
      >
        {tabCaptionList.map((item) => (
          <Tab key={item.id}
            className={isArrowTab & isPc ? 'arrow-tab-container' : isArrowTab ? 'arrow-tab-container-mobile' : ''}
          >{item.caption}</Tab>
        ))}
      </Tabs>
      {tabContents}
    </>
  );
}
export default CustomTabs;